import React from "react";

// 🎯 Calendar Icon
export const CalendarIcon = ({ size = 18, color = "#185FA5" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="1.5" />
        <path d="M16 2v4M8 2v4M3 10h18" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

// 🎯 Download Icon
export const DownloadIcon = ({ size = 16, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M12 3v13M7 11l5 5 5-5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 21h14" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

// 🎯 Chevron Right Icon
export const ChevronRightIcon = ({ size = 14, color = "#aaa" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M9 18l6-6-6-6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);


export const StarIcon = ({ filled, color }) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill={filled ? color : "none"} stroke={filled ? color : "#aaa"} strokeWidth="1.5">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" strokeLinejoin="round" />
    </svg>
);


export const ShoppingCartIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M3 3h2l.4 2M7 13h10l4-8H5.4" stroke="#185FA5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="9" cy="20" r="1.5" fill="#185FA5" />
        <circle cx="18" cy="20" r="1.5" fill="#185FA5" />
    </svg>
);


export const StatsIcon = ({ filled = false, color = "#185FA5" }) => (
    <svg width="16" height="16" viewBox="0 0 24 24">
        <rect x="3" y="10" width="3" height="10" fill={filled ? color : "none"} stroke={color} strokeWidth="1.5" />
        <rect x="10" y="4" width="3" height="16" fill={filled ? color : "none"} stroke={color} strokeWidth="1.5" />
        <rect x="17" y="14" width="3" height="6" fill={filled ? color : "none"} stroke={color} strokeWidth="1.5" />
    </svg>
);